import { connect } from 'react-redux';
import { compose } from 'recompose';

import UserModal from './UserModal';
import { closeUserModal, dispatchCreateUpdateUser } from '../actions';
import { getUser } from '../../../authentication/selectors';

const mapStateToProps = (state) => {
  return {
    showUserEntryModal: state.userList.showUserEntryModal,
    initialValues: state.userList.user,
    loggedInUser: getUser(state),
  };
};

const mapDispatchToProps = {
  closeUserModal,
  dispatchCreateUpdateUser,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(withRedux);

export default enhance(UserModal);
